// ИЖС
// Садоводство
// Фермерское хоз-во
// ДНП
// Земля промназначения

import suburbanBuildingStatus from './suburban-building-status';

export default suburbanBuildingStatus.filter(sbs =>
  [
    'individualHousingConstruction',
    'gardening',
    'farm',
    'privateFarm',
    'suburbanNonProfitPartnership',
    'industrialLand',
  ].includes(sbs.key),
);
